<template>
  <el-button
    class="text-center btn-outline-primary float-end mx-1 me-3"
    style="height: 38px"
    @click="dialogFormVisible = true"
    ><el-icon class="me-2"><Upload /></el-icon>ファイルインポート
  </el-button>
  <el-dialog v-model="dialogFormVisible" title="ファイルインポート">
    <el-upload class="upload-demo" :auto-upload="false" :on-change="handleFileChange" drag action="">
      <el-icon class="el-icon--upload"><UploadFilled /></el-icon>
      <div class="el-upload__text">
        ここに stry ファイルをドラッグ&ドロップするか、<em style="color: #91cdbe"
          >クリックしてアップロードしてください</em
        >
      </div>
    </el-upload>
    <div class="text-center mt-3 mb-2">
      <el-button @click="dialogFormVisible = false" class="btn-outline-primary mx-5 w-150px">キャンセル</el-button>
      <el-button @click="importFile" :disabled="!selectedFile" v-loading="saving" class="btn-primary mx-5 w-150px"
        >インポートする</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import http_method from '../mixins/http_method';
import redo_undo_method from '../mixins/redo_undo_method';
import content_method from '../mixins/content_method';
import caret_method from '../mixins/caret_method';
import hardware_action_method from '../mixins/hardware_action_method';
import set_range_method from '../mixins/set_range_method';
import pdf_method from '../mixins/pdf_method';
import { useCaretStore } from '../stores/caret_store.js';
import 'element-plus';
import { nextTick } from 'vue';
import * as CONSTS from '../constants.js';
import Content from './../classes/content.js';
import { ref } from 'vue';
import { el } from 'element-plus/es/locale/index.mjs';
export default {
  name: 'FileImport',
  data() {
    return {
      saving: false,
      dialogFormVisible: false,
      selectedFile: null, // アップロードされたファイル情報を保存
    };
  },
  mixins: [
    http_method,
    redo_undo_method,
    content_method,
    caret_method,
    hardware_action_method,
    set_range_method,
    pdf_method,
  ],
  methods: {
    // ファイル選択時のハンドラー
    handleFileChange(file) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (extension !== 'wr' && extension !== 'stry') {
        this.$message.error('STRYファイルを選択してください');
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    },

    // インポート実行
    async importFile() {
      this.saving = true;
      if (!this.selectedFile) {
        this.$message.error('ファイルを選択してください');
        this.saving = false;
        return;
      }
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const fileContent = JSON.parse(e.target.result);
          console.log('ファイルの中身:', fileContent);

          let formData = new FormData();
          formData.append(`document[title]`, fileContent.title);

          fileContent.content
            .sort((a, b) => {
              return a.sort_key - b.sort_key;
            })
            .forEach((content) => {
              formData.append(`document[sentences_attributes][][body]`, content.body);
              formData.append(`document[sentences_attributes][][tag_type]`, content.tag_type);
              formData.append(`document[sentences_attributes][][sort_key]`, content.sort_key);
              content.style.forEach((style) => {
                formData.append(`document[sentences_attributes][][styles_attributes][][style_type]`, style.style_type);
                formData.append(`document[sentences_attributes][][styles_attributes][][color]`, style.color);
                formData.append(
                  `document[sentences_attributes][][styles_attributes][][start_index]`,
                  style.start_index,
                );
                formData.append(`document[sentences_attributes][][styles_attributes][][end_index]`, style.end_index);
              });
            });

          const response = await this.postMethod(
            formData,
            `/documents/${fileContent.documentId}/copy_document.json`,
            '保存に失敗しました',
          );

          if (response && response.status == 201) {
            this.announceMessage('success', 'インポートに成功しました');
            this.selectedFile = null;
            this.dialogFormVisible = false;
            // メッセージ表示用の時間を確保してからリダイレクト
            setTimeout(() => {
              location.href = response.data.url;
            }, 1000);
          } else {
            this.announceMessage('error', 'インポートに失敗しました');
          }
        } catch (error) {
          console.error('ファイルの読み取りエラー:', error);
          this.$message.error('ファイルの形式が正しくありません');
        } finally {
          this.saving = false;
        }
      };
      reader.onerror = () => {
        this.$message.error('ファイルの読み取りに失敗しました');
        this.saving = false;
      };
      reader.readAsText(this.selectedFile.raw);
    },
  },
};
</script>
